<div class="create-dialog-box scrollable-dialog container">
    <div class="title d-flex align-items-center justify-content-space-between">
        <h4 class="mb-0"> Update</h4>
        <button class="close-btn bg-transparent p-0 border-none" (click)="close()"><i
                class="flaticon-close"></i></button>
    </div>
    <form (ngSubmit)="addTag()" [formGroup]="form">
        <!-- <div class="col-lg-12">
            <mat-form-field appearance="outline" class="w-100">
                <mat-label>Status</mat-label>
                <mat-select class="form-control" formControlName="status">
                    <mat-option value="new">New</mat-option>
                    <mat-option value="approved">Approved</mat-option>
                    <mat-option value="pending">Pending</mat-option>
                    <mat-option value="declined">Decline</mat-option>
                </mat-select>
            </mat-form-field>
        </div> -->

        <div class="col-lg-12">
            <mat-form-field appearance="outline" class="w-100">
                <mat-label class="form-label">Enter Tag Name</mat-label>
                <textarea matInput placeholder="Please Enter Comment" class="form-control" rows="5" formControlName="tagName"></textarea>
            </mat-form-field>
        </div>
    
        <div class="text-center">
            <button
                type="submit"
                mat-flat-button
                class="tagus fw-semibold"
            >
                Add Tag
            </button>
            <!-- <button mat-button mat-dialog-close type="button" style="order: 2;">Cancel</button> -->
        </div>
        
    </form>
    
    
</div>